import axios from "axios";

export default axios.create({
  // baseURL: "http://localhost:8000/",
  //  baseURL: "http://103.13.211.35:82/",
  baseURL: "https://ntsp.tourkenya.go.ke/",
  headers: {
    "Content-Type":
      "multipart/form-data; boundary=<calculated when request is sent>",
    "Access-Control-Allow-Origin": "*",
    Accept: "*/*",
    // Authorization: "Bearer " + window.sessionStorage.getItem("xtoken"),
  },
});
